import Controller from '@ember/controller';
import DS from 'ember-data';
import { inject as service } from '@ember/service';
import { action, computed } from '@ember/object';
import { task } from 'ember-concurrency';
import RouterService from '@ember/routing/router-service';
import AlertsService from 'cio/services/alerts';
import WebhookModel from 'cio/models/webhook';

export default class IntegrationsReportingWebhooksEdit extends Controller {
  @service store!: DS.Store;
  @service router!: RouterService;
  @service alerts!: AlertsService;

  declare model: WebhookModel;

  @computed('model.hasDirtyAttributes')
  get isDirty() {
    return this.model.hasDirtyAttributes;
  }

  @action
  cancelNewWebhook() {
    this.router.transitionTo('integrations.reporting-webhooks.index');
  }

  saveWebhook = task({ drop: true }, async () => {
    try {
      if (!this.model.events?.length) {
        this.model.set('enabled', false);
      }

      await this.model.save();

      this.alerts.success(
        'integrations.reporting-webhooks.edit.success',
        `${this.model.name || 'Your webhook'} has been updated`,
      );

      this.router.transitionTo('integrations.reporting-webhooks.index');
    } catch {
      this.alerts.error(
        'integrations.reporting-webhooks.edit.error',
        'Something went wrong when we tried to update your webhook. Please try again.',
        'Uh oh',
      );
    }
  });

  fetchWebhooks = task({ keepLatest: true }, async () => {
    try {
      return await this.store.findAll('webhook');
    } catch {
      // Don't throw, just let this fail since it's not critical and only for validations
    }

    return;
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'integrations/reporting-webhooks/edit': IntegrationsReportingWebhooksEdit;
  }
}
